export default __webpack_public_path__ + "static/media/pokemon_electric.007b45e5.png";